
import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";


type BaseMenuListProps = {
  links: { label: string; path: string, slug?: string }[];
  onNavigate: (path: string, slug?: string) => void;
  user: string | null;
};

function LanguageSwitcher({ language }: { language: string }) {
  return (
    <>
      <span style={{ fontWeight: language === "th" ? "bold" : "normal" }}>ไทย</span>
      /
      <span style={{ fontWeight: language === "en" ? "bold" : "normal" }}>EN</span>
    </>
  );
}


export default function BaseMenuList({ links, onNavigate, user }: BaseMenuListProps) {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const filteredLinks = links.filter((link) =>
    link.label === t("menu.logout") ? user : true
  );

  return (
    <List>
      {filteredLinks.map((link, idx) => {
        const isLang = link.path === "#change-lang";
        return (
          <ListItem key={link.label} disablePadding>
            <ListItemButton
              onClick={() => onNavigate(link.path, link.slug)}
              sx={{
                borderBottom:
                  idx < filteredLinks.length - 1 ? "1px solid #3F4E8C" : "none",
              }}
            >
              <ListItemText
                primary={isLang ? <LanguageSwitcher language={language} /> : link.label}
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
}
